import makeApi from './api';

export default async function fetchConsent() {
  const api = makeApi();
  const response = await api.get('/api/v1/content/terms-of-use-privacy-policy');
  return response.data;
}
